import React, {FC} from 'react';
import styles from './StepDocuments.module.scss';
import {DifferentDocument} from '../../../../profile/Documents/DocumentsElements/DifferentDocument';
import {File, ProjectDocument} from '../../../../../../../api-client';

interface StepDocumentsProps {
  documents?: ProjectDocument[];
}

const financingDocuments: ProjectDocument[] = [
  {
    name: 'Заявка на размещение инвестиционного предложения',
    publicationDate: new Date(2026, 3, 10),
    file: new File('Заявка на размещение инвестиционного предложения.docx',
      'https://cdn.conomica-finance.ru/file/3176b/3f7/12cb-d986e/zayavka-na-razmeshhenie-investicionnogo-predlozeniya.docx', 20),
  },
  {
    name: 'Договор привлечения финансирования (займа)',
    publicationDate: new Date(2026, 3, 10),
    file: new File('Договор привлечения финансирования (займа).docx', 'https://cdn.conomica-finance.ru/file/3176b/3f7/1532-d6952/dogovor-privleceniya-finansirovaniya-zaima.docx',51),
  },
];

const securityDocuments: ProjectDocument[] = [
  {
    name: 'Договор обеспечения (с регрессом)',
    publicationDate: new Date(2026, 3, 10),
    file: new File('Договор обеспечения (с регрессом).docx', 'https://cdn.conomica-finance.ru/file/3176b/3f7/172a-c0be6/dogovor-obespeceniya-s-regressom-2.docx', 26),
  },
  {
    name: 'Договор обеспечения (без регресса)',
    publicationDate: new Date(2026, 3, 10),
    file: new File('Договор обеспечения (без регресса).docx', 'https://cdn.conomica-finance.ru/file/3176b/3f8/00da-ba332/dogovor-obespeceniya-bez-regressa.docx', 29),
  }
];

const PROCEDURE_STEPS = [
  {
    title: 'Направление предварительных договоров.',
    description: (
      <>
        Платформа направит Вам в ЛК уведомление о готовности проектов договоров. Ознакомиться можно{' '}
        <a href="/" className={styles.procedureLink}>здесь</a>
        {' '}и на эл. почте.
      </>
    ),
  },
  {
    title: 'Согласование документов',
    description: 'Платформа и заемщик согласовывают итоговый текст договоров',
  },
  {
    title: 'Подписание',
    description:
      'Платформа направит Вам приглашение на подписание согласованных договоров в системе Контур.Диадок. Ссылка для подписания будет направлена в ЛК в раздел Уведомления и на эл. почту',
  },
];

const StepDocuments: FC<StepDocumentsProps> = ({
  documents,
}) => {
  const financing = documents?.length ? documents.slice(0, 2) : financingDocuments;
  const security = documents?.length ? documents.slice(2) : securityDocuments;

  return (
    <div className={styles.stepDocuments}>
      <p className={styles.introText}>
        Перед размещением Оферты на Платформе необходимо подписать с помощью УКЭП пакет документов,
        подготавливаемый Платформой.
      </p>

      <p className={styles.procedureTitle}>Порядок действий:</p>
      <div className={styles.procedureBlock}>
        {PROCEDURE_STEPS.map((step, index) => (
          <div key={index} className={styles.procedureStep}>
            <div className={styles.procedureNumber} aria-hidden>
              {index + 1}
            </div>
            <div className={styles.procedureContent}>
              <p className={styles.procedureStepTitle}>{step.title}</p>
              <p className={styles.procedureStepDescription}>{step.description}</p>
            </div>
          </div>
        ))}
      </div>

      <h2 className={styles.documentsLabel}>Образцы документов, применяемые на Платформе:</h2>

      <p className={styles.categoryLabel}>Бланки документов для привлечения финансирования:</p>
      <div className={styles.documentsGrid}>
        {financing.map((doc) => (
          <div key={doc.name} className={styles.documentCard}>
            <DifferentDocument document={doc} />
          </div>
        ))}
      </div>

      <p className={styles.categoryLabel}>Бланки документов обеспечения (опционально):</p>
      <div className={styles.documentsGrid}>
        {security.map((doc) => (
          <div key={doc.name} className={styles.documentCard}>
            <DifferentDocument document={doc} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepDocuments;

